export default __webpack_public_path__ + "static/media/IconHog.8ae67aec.png";